import Resource from './Resource';
import {BaseSignableDocuments} from "./SignableDocuments";

/**
 * VehicleReservation Resource
 */
class VehicleReservation extends Resource
{
    constructor() {
        super('reservation', ['vehicle-reservations']);
    }

    cancel(id, params = {}) {
        return this._doPost([id, 'cancel'], params);
    }

    /**
     * Convert the reservation to a deal.
     * s
     * @param id
     * @returns {*}
     */
    convert(id, params = {}) {
        return this._doPost([id, 'convert'], {}, params);
    }
}

export let VehicleReservationResource = new VehicleReservation();

/**
 * VehicleReservation Schema
 * @param {Object} defaults [description]
 */
export let VehicleReservationSchema = function(defaults = {}) {
    let schema = {
        contact_id: null,
        expires_at: null,
        instance_id: null,
        created_by_id: null,
        sales_person_id: null,
        invoice_id: null,
        type: null,
        cancelled_at: null,
        notes: null,
        deal_id: null,
        deposit_amount: null,
        payment_method: null,
        payment_reference: null,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
};

export class SignableReservationReceipt extends BaseSignableDocuments
{
    constructor() {
        super('vehicle-reservations');
    }

    forReservation(reservation_id) {
        return this.forModel(reservation_id)
    }
}

export let SignableReservationReceiptResource = new SignableReservationReceipt()

export let VehicleReservationTypes = {
    TYPE_WEB: 'web',
    TYPE_SALESMAN: 'salesman',
}